import SettingsList from '../components/SettingsList';
import SettingsHeader from '../components/SettingsHeader';
import {NotificationSettingsListWithContext} from '../context/SettingsListContext';
import {PageContainer} from '@vidazoo/ui-kit';
import theme from './theme.module.scss';

export default function NotificationSettings() {

    return (
        <NotificationSettingsListWithContext>
            <PageContainer pageTitle="Notification Settings" className={theme.page} style={{padding: 0}}>
                <SettingsHeader/>
                <SettingsList/>
            </PageContainer>
        </NotificationSettingsListWithContext>
    );
}
